import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Tag } from "lucide-react";
import { api } from "@/lib/api";

export const MAX_VISIBLE_NOTICES = 3;

// Round N — "Nieuw antwoord op je trefwoord …", in dezelfde stijl als ChallengeNotices. Fail-soft.
export const KeywordNotices = ({ user, prefix = "keyword-notices" }) => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/keywords/notices");
      setRows(Array.isArray(data) ? data : []);
    } catch { setRows([]); }
  }, []);
  useEffect(() => { if (user?.role !== "lezer") load(); }, [user, load]);
  const seen = async (id) => {
    try {
      await api.post(`/keywords/notices/${id}/seen`);
      setError("");
      setRows((prev) => prev.filter((r) => r.id !== id));
    } catch { setError("Dat lukte niet. Probeer het zo opnieuw."); }
  };
  if (!rows.length) return null;
  return <section className="my-5" data-testid={prefix}>
    {rows.slice(0, MAX_VISIBLE_NOTICES).map((row) => <div className="game-challenge flex flex-wrap items-center justify-between gap-3" key={row.id} data-testid={`${prefix}-item-${row.id}`}>
      <div className="min-w-0 flex-1">
        <p className="flex gap-2 text-tw-yellow text-xs font-mono uppercase tracking-widest mb-1"><Tag size={14} />Trefwoord</p>
        <p className="text-sm break-words" data-testid={`${prefix}-text-${row.id}`}>Nieuw antwoord op je trefwoord {row.keyword_word}: {row.question_text}</p>
        <Link to={`/bibliotheek?memo=${row.recording_id}`} className="text-xs text-white underline underline-offset-4 decoration-tw-yellow/60 hover:text-tw-yellow" data-testid={`${prefix}-open-${row.id}`}>Bekijk de memo in de Bibliotheek</Link>
      </div>
      <button type="button" className="game-secondary" onClick={() => seen(row.id)} data-testid={`${prefix}-seen-${row.id}`}><Check size={14} />Gezien</button>
    </div>)}
    {error && <p role="alert" className="text-tw-red text-sm" data-testid={`${prefix}-error`}>{error}</p>}
  </section>;
};
